<template>
  <!-- //인증 이벤트 시작 -->
  <div class="widM txtC bgFullX marTX padTX padBX padLS padRS" :style="cssProps" style="color:#000;background-size:100% 100%">
    <p class="fntH5 fntL"><b class="light">여기서 끝이 아니다!</b></p>
    <p class="fntH2 marTS"><strong>아티스트리가 마구마구 쏩니다!</strong></p>
    <div class="marTX"><img src="@/assets/images/relay-event/logo_02.png" alt="인스타그램 로고" class="icoS"></div>
    <p class="fntH6 marTX">
      스킨 뉴트리션 미니 제품을 체험하신 후<br>
      인스타그램에 아래 해시태그와 후기를 남겨주세요.<br>
      추첨을 통해 선물을 보내 드립니다.
    </p>
    <p class="fntH5 fntL marTL"><b class="disIb">#A7070</b> <b class="disIb">#아티스트리</b> <b class="disIb">#스킨뉴트리션</b><br class="pcOnly"> <b class="disIb">#건강한안티에이징의시작</b></p>
    <p class="fntH6 marTL">
      A7070이 마무리되는 <b>3월</b>,<br>
      본인 <b>인스타그램의 DM</b>을 확인해주세요!<br>
      (별도의 공지 없이 당첨자에 한해 DM 발송됩니다.)
    </p>
  </div>
  <!-- //인증 이벤트 끝 -->
</template>
<script>
  export default {
    data() {
      return {
        cssProps: {
          backgroundImage: `url(${require('@/assets/images/relay-event/bg_01.jpg')})`
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/nutrilite/relayevent/component/footer_event.vue